import React, { createContext, useContext } from "react";
import { SegmentClient } from "@segment/analytics-react-native";

export const SurveySegmentClientContext = createContext<
  SegmentClient | undefined
>(undefined);

export const useSurveySegmentClient = () =>
  useContext(SurveySegmentClientContext);

export const SurveySegmentClientProvider = ({
  client,
  children,
}: {
  client: SegmentClient;
  children: React.ReactNode;
}) => (
  <SurveySegmentClientContext.Provider value={client}>
    {children}
  </SurveySegmentClientContext.Provider>
);
